export default __webpack_public_path__ + "static/media/pl_PL.763e2468.svg";